"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
require("./scss/styles.scss");
const HRGRAPH = __importStar(require("./Graph/GraphHR"));
const BPGraph = __importStar(require("./Graph/GraphBP"));
const UISettings = __importStar(require("./UI/SettingsPanel"));
const UIDisplay = __importStar(require("./UI/DisplayPanel"));
const UIPacer = __importStar(require("./UI/PacerPanel"));
var $ = require('jquery');
require('../node_modules/jquery-ui/dist/jquery-ui.min.js');
$(() => {
    // MONITOR events
    UIDisplay.Setup("#mon-area .value, #nX");
    // SETTINGS events
    UISettings.Setup("#_settings input, #_settings select");
    // PACER events
    UIPacer.Setup("#_pacer input, #_pacer select");
    HRGRAPH.Init("canvashr");
    BPGraph.Init("canvasbp");
    $("#_pacer").draggable({ containment: "window", stack: "section" });
    $("#_settings").draggable({ containment: "window", stack: "section" });
});
